import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 122,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: theme.spacing(1, 0.25),
      borderRadius: theme.shape.borderRadius,
      border: theme.shape.borderPrimaryLight,
      backgroundColor: COLORS.neutral.white,

      '&:hover': {
        backgroundColor: COLORS.primary.silver,

        '& $text': {
          color: COLORS.neutral.secondary,
        },
      },
      '&:focus': {
        backgroundColor: COLORS.primary.silver,
      },
      '&$selected': {
        backgroundColor: COLORS.primary.silver,
        borderColor: COLORS.primary.default,

        '& $text': {
          color: COLORS.neutral.secondary,
        },
      },
      '&:disabled': {
        opacity: 0.5,
      },
    },
    selected: {},

    avatar: {
      fontSize: theme.typography.pxToRem(42),
    },

    textWrapper: {
      height: '100%',
      width: '100%',
      padding: theme.spacing(0, 0.5),
      marginTop: theme.spacing(0.75),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },

    text: {
      maxHeight: 32,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.secondary,
      width: '100%',
      whiteSpace: 'unset',
    },

    selectedText: {
      fontWeight: theme.typography.fontWeightMedium,
    },

    suggested: {
      color: COLORS.neutral.mediumGray,
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.pxToRem(10),
      background: COLORS.primary.silver,
      borderRadius: 3,
      padding: theme.spacing(0.5),
    },
  }),
  { name: 'PersonaButton' }
);
